import React from "react";

import { Icon } from "semantic-ui-react";
import { getShortDate, getStatusInfo } from "../../utils/helperFunctions";
import useTheme from "../../hooks/useTheme";
import { withOpacity } from '../../utils/helperFunctions';
import AppText from "../UI/Texts/AppTexts";
import { AppColumn, AppRow } from "./Layouts";
import { t } from "i18next";
import { SizedBox } from "./Sizes";


export const CandidateStatusCard = ({ candidateData, basic }) => {
    const theme = useTheme();
    const { statusMessages, status: statusData } = candidateData;
    const { status: currentStatus, statusLabel, updatedAt, history } = statusData;

    const newStatusMessages = Object.entries(statusMessages ?? {});

    let steps = []

    if (currentStatus !== 'rejected') {
        steps = [
            { key: currentStatus, date: updatedAt, completed: true },
            ...Object.entries(history??{}).map((data) => {
                return { key: data[1], date: parseInt(data[0]), completed: true }
            })
        ]
    } else {
        steps = [
            ...Object.entries(history).map((data) => {
                return { key: data[1], date: parseInt(data[0]), completed: true }
            })
        ]
    }

    const sortedSteps = steps.sort((a, b) => new Date(a.date) - new Date(b.date));
    const lastStatusData = sortedSteps[steps.length - 1];

    const rejectedStatus = newStatusMessages?.find(([status, messageData]) => status === 'rejected');

    const sortedStatusMessages = newStatusMessages?.sort((a, b) => new Date(a[1].createdAt) - new Date(b[1].createdAt));

    const needsFeedback = sortedStatusMessages?.find(([status, messageData]) => messageData.answerType === 'answer2');


    const showAlart = (() => {
        if (rejectedStatus) {
            return true;
        } else if (needsFeedback) {
            return true;
        }
        return false;

    })()


    const statusTitle = getStatusInfo(rejectedStatus ? lastStatusData.key : currentStatus, showAlart, statusLabel).title;
    const statusColor = getStatusInfo(currentStatus, showAlart, statusLabel).color;


    const iconName = (() => {
        if (rejectedStatus) {
            return 'frown outline';
        } else if (needsFeedback) {
            return 'exclamation circle';
        }
    })()

    return (<div style={{
        height: '30px',
        maxWidth: '100%',
        position: 'relative'

    }}>
        <div style={{
            backgroundColor: !basic && withOpacity(statusColor, '0.1'),
            paddingLeft: !basic && theme.spacing.elementPaddingSmall,
            paddingRight: !basic && theme.spacing.elementPaddingSmall,
            height: !basic && '30px',
            borderRadius: theme.radius.small,
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
        }}>
            <AppText.FootnoteSmall color={statusColor}>{statusTitle}</AppText.FootnoteSmall>
        </div>

        {iconName &&
            <AppRow
                mainAxisAlignment={'center'}
                crossAxisAlignment={'center'}
                style={{

                    position: 'absolute',
                    right: '-10px',
                    top: '-10px',


                    borderRadius: '50%',
                    zIndex: 1,

                    backgroundColor: theme.colors.white,

                    height: '20px',
                    width: '20px',


                }}
            >
                <Icon name={iconName} style={{
                    fontSize: '1.2rem',
                    color: theme.colors.dark,
                    borderRadius: '50%',

                    

                    paddingTop: '-8px',
                    paddingBottom: '8px',
                    paddingLeft: '2.5px',
                    paddingRight: '0px',    

                }} />


            </AppRow>}
    </div>)
}




export const CandidateStatusVerticalStepper = ({ candidateData }) => {
    const theme = useTheme();

    const { statusMessages, status: statusData } = candidateData
    const { status: currentStatus, statusLabel, history, updatedAt } = statusData;

    let steps = []

    if (currentStatus) {

        const historySteps = Object.entries(history)
            .filter(([, status]) => status !== 'archived')
            .map((data) => {
                return { key: data[1], date: parseInt(data[0]), completed: true }
            });

        if (currentStatus !== 'rejected' && currentStatus !== 'archived') {
            steps = [
                { key: currentStatus, date: updatedAt, completed: true, statusLabel },
                ...historySteps
            ]
        } else {
            steps = [...historySteps]
        }

        const sortedSteps = steps.sort((a, b) => new Date(a.date) - new Date(b.date));

        const lastStatusData = sortedSteps[steps.length - 1];


        if (statusMessages) {

            const newStatusMessages = Object.entries(statusMessages);

            const rejectedStatus = newStatusMessages.find(([status, messageData]) => status === 'rejected');

            if (rejectedStatus) {
                const [status, messageData] = rejectedStatus;

                steps = steps.filter((step) => step.key !== lastStatusData.key);
                steps.push({ key: lastStatusData.key, date: updatedAt, completed: false, message: messageData.message, rejected: true })
            } else {
                newStatusMessages.forEach(([status, messageData]) => {
                    if (messageData.answerType === 'answer2') {
                        steps.push({ key: status, date: updatedAt, completed: false, message: messageData.message })
                    }
                })
            }

        }
    }


    const getStepIcon = ({ active, disabled, completed, rejected }) => {

        if (disabled || rejected) {
            return <Icon name="frown outline" size='large' style={{
                color: rejected ? theme.colors.dark : theme.colors.grey,
            }} />
        } else if (completed) {
            return <Icon name="exclamation circle" size='large' style={{
                color: theme.colors.dark,
            }} />;
        } else if (active) {
            return <Icon name="check circle" size='large' style={{
                color: theme.primaryColor
            }} />
        } else {
            return <Icon name="circle outline" size='large' color="grey" />;
        }
    };





    steps = steps.sort((a, b) => new Date(a.date) - new Date(b.date));


    return (
        <div>
            <SizedBox height={theme.spacing.elementPadding} />
            {steps.map((step, index) => {
                const disabled = ['not_accepted', 'not_interested'].includes(step.key);

                return (<div key={step.key} style={{ display: 'flex', alignItems: 'start', position: 'relative', marginBottom: theme.spacing.contentPadding }}>
                    {index !== 0 && (
                        <div style={{
                            position: 'absolute',
                            left: '10.5px',
                            top: '-25px',
                            width: '2px',
                            height: '25px',
                            backgroundColor: theme.colors.grey
                        }} />
                    )}
                    <div style={{
                        marginRight: '10px', zIndex: 1,
                        marginTop: theme.spacing.elementPadding,

                    }}>{getStepIcon({
                        active: step.key,
                        disabled: disabled,
                        completed: !step.completed,
                        rejected: step?.rejected,
                    })}</div>
                    <AppRow>
                        <AppColumn crossAxisAlignment={'start'}>
                            <AppText.Caption>{getApplicationStatusTitle(step.key, { defaultText: step.statusLabel || t(step.key), completed: step.completed })}</AppText.Caption>
                            {step?.date && (
                                <AppColumn>
                                    <SizedBox height={theme.spacing.elementPaddingSmall} />
                                    <AppText.FootnoteSmall color={theme.colors.grey}>{getShortDate(step?.date)}</AppText.FootnoteSmall>
                                </AppColumn>)}
                            {step.message && <AppColumn>
                                <SizedBox height={theme.spacing.elementPadding} />
                                <CandidateStatusEventMessageBubbleCard messageText={step.message} />
                                <SizedBox height={theme.spacing.contentPadding} />
                            </AppColumn>}

                        </AppColumn>


                    </AppRow>
                </div>
                );
            })}
        </div>

    );
};


const CandidateStatusEventMessageBubbleCard = ({ messageText }) => {
    const theme = useTheme();
    return (<div>
        <div style={{
            padding: theme.spacing.elementPadding,
            borderRadius: theme.radius.default,

            border: "none",
            backgroundColor: withOpacity(theme.colors.lightGrey, '0.6'),
        }}>
            <AppColumn>
                <AppText.Footnote color={theme.colors.dark}>{messageText}</AppText.Footnote>
            </AppColumn>
        </div>
    </div>
    )
}



function getApplicationStatusTitle(key, { defaultText, completed }) {

    const state = {
        interested: "Intresserad",
        qualified: defaultText,
        documented: defaultText,
        presented: defaultText,
        accepted: "Grattis! Du har blivit accepterad för uppdraget.",
        not_accepted: "Tyvärr verkar det inte gå framåt denna gång.",
        rejected: defaultText,
        archived: t("archived"),
    }

    // Fall back to defaultText for custom pipeline stages not in the map
    return completed ? (state[key] ?? defaultText) : defaultText;
}

